import React from "react";
import { Link } from "react-router-dom";
import { Gift, MapPin, Pizza, Ruler, Tag, GlassWater, RotateCw, Store } from "lucide-react";

import PageHeader from "../../components/PageHeader";

const CARD_LINK_CLASS =
  "group flex flex-col rounded-2xl border border-neutral-200 bg-white p-6 shadow-sm outline-none transition-all hover:border-primary/40 hover:shadow-md focus-visible:ring-2 focus-visible:ring-primary";

const Relatorios: React.FC = () => {
  return (
    <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <PageHeader
        title="Relatórios"
        description="Escolha um relatório para abrir o painel."
      />

      <section className="mt-8" aria-label="Relatórios disponíveis">
        <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
          <Link to="/relatorios/pizzas-brinde" className={CARD_LINK_CLASS}>
            <div className="mb-3 flex items-start justify-between gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-white shadow-inner">
                <Gift size={26} strokeWidth={2} />
              </div>
              <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-800">
                Abrir
              </span>
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 group-hover:text-primary">
              Pizzas brinde
            </h3>
            <p className="mt-2 flex-1 text-sm text-neutral-600">
              Totais por loja, tamanho, sabor, categoria e motivo — pizzas
              finalizadas na fila (integração).
            </p>
          </Link>

          <Link to="/relatorios/pizzas-promocoes" className={CARD_LINK_CLASS}>
            <div className="mb-3 flex items-start justify-between gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-white shadow-inner">
                <Tag size={26} strokeWidth={2} />
              </div>
              <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-800">
                Abrir
              </span>
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 group-hover:text-primary">
              Pizzas em promoções
            </h3>
            <p className="mt-2 flex-1 text-sm text-neutral-600">
              Vendas por promoção nos pedidos de integração, com sabores
              extraídos das opções (meia/meia divide a quantidade).
            </p>
          </Link>

          <Link to="/relatorios/pedidos-por-bairro" className={CARD_LINK_CLASS}>
            <div className="mb-3 flex items-start justify-between gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-white shadow-inner">
                <MapPin size={26} strokeWidth={2} />
              </div>
              <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-800">
                Abrir
              </span>
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 group-hover:text-primary">
              Pedidos por bairro
            </h3>
            <p className="mt-2 flex-1 text-sm text-neutral-600">
              Apenas pedidos{" "}
              <code className="rounded bg-neutral-100 px-1 text-[11px]">
                order_type = delivery
              </code>
              ; contagem por loja e bairro em{" "}
              <code className="rounded bg-neutral-100 px-1 text-[11px]">
                delivery_address.neighborhood
              </code>
              .
            </p>
          </Link>

          <Link to="/relatorios/pizzas-por-sabor" className={CARD_LINK_CLASS}>
            <div className="mb-3 flex items-start justify-between gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-white shadow-inner">
                <Pizza size={26} strokeWidth={2} />
              </div>
              <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-800">
                Abrir
              </span>
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 group-hover:text-primary">
              Pizzas por sabor
            </h3>
            <p className="mt-2 flex-1 text-sm text-neutral-600">
              Tabela, KPIs, gráficos pizza e barras — exportação Excel e PDF.
            </p>
          </Link>

          <Link to="/relatorios/pizzas-por-tamanho" className={CARD_LINK_CLASS}>
            <div className="mb-3 flex items-start justify-between gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-white shadow-inner">
                <Ruler size={26} strokeWidth={2} />
              </div>
              <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-800">
                Abrir
              </span>
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 group-hover:text-primary">
              Pizzas por tamanho
            </h3>
            <p className="mt-2 flex-1 text-sm text-neutral-600">
              Contagem de produções finalizadas por tamanho cadastrado (mesma
              base que Pizzas por sabor).
            </p>
          </Link>

          <Link to="/relatorios/bebidas" className={CARD_LINK_CLASS}>
            <div className="mb-3 flex items-start justify-between gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-white shadow-inner">
                <GlassWater size={26} strokeWidth={2} />
              </div>
              <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-800">
                Abrir
              </span>
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 group-hover:text-primary">
              Bebidas
            </h3>
            <p className="mt-2 flex-1 text-sm text-neutral-600">
              Vendas de bebidas nos pedidos de integração — itens avulsos e
              refrigerantes escolhidos em combos e pizzas.
            </p>
          </Link>

          <Link to="/relatorios/salao-pizzas" className={CARD_LINK_CLASS}>
            <div className="mb-3 flex items-start justify-between gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-white shadow-inner">
                <Store size={26} strokeWidth={2} />
              </div>
              <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-800">
                Abrir
              </span>
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 group-hover:text-primary">
              Pizzas Salão
            </h3>
            <p className="mt-2 flex-1 text-sm text-neutral-600">
              Salão/balcão Foodfly e rodízio no mesmo relatório — salão
              primeiro, rodízio em seguida, com totais separados.
            </p>
          </Link>

          <Link to="/relatorios/salao-bebidas" className={CARD_LINK_CLASS}>
            <div className="mb-3 flex items-start justify-between gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-white shadow-inner">
                <GlassWater size={26} strokeWidth={2} />
              </div>
              <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-800">
                Abrir
              </span>
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 group-hover:text-primary">
              Bebidas Salão
            </h3>
            <p className="mt-2 flex-1 text-sm text-neutral-600">
              Bebidas finalizadas na fila do salão FoodFly — mesma base do KPI
              de bebidas do dashboard.
            </p>
          </Link>

          <Link to="/relatorios/rodizio-pizzas" className={CARD_LINK_CLASS}>
            <div className="mb-3 flex items-start justify-between gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-white shadow-inner">
                <RotateCw size={26} strokeWidth={2} />
              </div>
              <span className="rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-800">
                Abrir
              </span>
            </div>
            <h3 className="text-lg font-semibold text-neutral-900 group-hover:text-primary">
              Rodízio de Pizzas
            </h3>
            <p className="mt-2 flex-1 text-sm text-neutral-600">
              Sabores, tamanhos e quantidades das pizzas de rodízio
              finalizadas — mesma base do «Qtd. Rodízio» do dashboard.
            </p>
          </Link>
        </div>
      </section>
    </main>
  );
};

export default Relatorios;
